<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.docket-selector-audit-report.edit.formation.docketSelectorSelection', formControlNames: ''}">
        <fui-rows>
            <fui-row>
                <fui-column>
                    <wbo-meta-tag-multi-select-edit-control
                        [(ngModel)]="model.data.metaTags"
                        [type]="MetaTagType.DOCKET_SELECTOR"
                        [includeMatchNoTags]="true"
                        [multiObjectValueType]="false"
                        formControlName="metaTags">
                    </wbo-meta-tag-multi-select-edit-control>
                </fui-column>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
</wbo-report-page>
